import { DashboardWidget } from "./DashboardWidget";

export class Dashboard {
    id: number;
    title: string = "";
    icon: string = "bell";
    createdBy: string;
    shared: boolean = false;
    sharingToken: string;

    widgets: DashboardWidget[] = [];

    fillFromJson(data: any, breakpoint: string) {
        this.id = data.Id;
        this.title = data.Title;
        this.icon = data.Icon;
        this.createdBy = data.CreatedBy.Name;
        this.shared = data.SharedClientProfiles.length > 0;
        this.sharingToken = data.SharingToken;

        if (data.Widgets && data.Widgets.length > 0) {
            data.Widgets.forEach((e) => {
                var w: DashboardWidget = new DashboardWidget();
                w.fillFromJson(e, breakpoint);
                this.widgets.push(w);
            });
        }
    }

    clone(): Dashboard {
        var res = new Dashboard();
        res.id = this.id;
        res.title = this.title;
        res.icon = this.icon;
        res.createdBy = this.createdBy;
        res.shared = this.shared;
        res.sharingToken = this.sharingToken;

        res.widgets = [];
        this.widgets.forEach((w) => {
            res.widgets.push(w.clone());
        });
        return res;
    }
}
